export const OrganisationLevel = Object.freeze({
  Country: 'Country',
  Division: 'Division',
  Team: 'Team',
  Admin: 'Admin',
  Location: 'Location',
  Client: 'Client',
  ClientGroup: 'ClientGroup',
  Manager: 'Manager',
})
